<template>
    <v-dialog v-model="dialogVisible" max-width="600">
        <v-card>
            <v-card-title class="d-flex justify-space-between align-center">
                <span>{{ title }}</span>
                <v-btn icon="mdi-close" variant="text" @click="closeDialog"></v-btn>
            </v-card-title>
            <v-card-text>
                <v-list v-if="items && items.length > 0" density="compact">
                    <v-list-item v-for="(item, index) in items" :key="index">
                        <v-list-item-title>{{ item.code }}</v-list-item-title>
                    </v-list-item>
                </v-list>
                <v-alert v-else type="info" variant="tonal"> No data available </v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="closeDialog">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
    name: 'MasterDataReferenceDialog',

    props: {
        modelValue: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            default: () => []
        }
    },

    emits: ['update:modelValue'],

    setup(props, { emit }) {
        const dialogVisible = computed({
            get: () => props.modelValue,
            set: (value: boolean) => emit('update:modelValue', value)
        });

        const closeDialog = () => {
            dialogVisible.value = false;
        };

        return {
            dialogVisible,
            closeDialog
        };
    }
});
</script>

<style scoped>
.v-list {
    max-height: 400px;
    overflow-y: auto;
}
</style>
